import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {ImpuestoDTO} from '../../../models/dtos/ImpuestoDTO';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import {EmisionCfeService} from '../../services/emision-cfe.service';
import {DatosDetalleCFEDTO} from '../../../models/dtos/datosInicio/DatosDetalleCFEDTO';
import {TipoRetencionDTO} from '../../../models/dtos/TipoRetencionDTO';
import {TipoCFEDTO} from '../../../models/dtos/TipoCFEDTO';
import {DetalleTipoCodigoDTO} from '../../../models/dtos/DetalleTipoCodigoDTO';
import {TipoCodigoDTO} from '../../../models/dtos/TipoCodigoDTO';
import {Utils} from '../../utils/utils';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TiposPesoDTO} from '../../../models/dtos/TiposPesoDTO';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {ReceptorCFEDTO} from '../../../models/dtos/ReceptorCFEDTO';

@Component
({
  selector: 'app-detalle-cfe',
  templateUrl: './detalle-cfe.component.html',
  styleUrls: ['./detalle-cfe.component.scss']
})
export class DetalleCfeComponent implements OnInit {
  formGroup: FormGroup;
  codigoDinamicFormGroup: FormGroup;
  tipoCodigoFormGroup: FormGroup;
  tipCodigos: TipoCodigoDTO[] = [];
  canAccept: boolean = true;
  emisorEsLiteralE;
  selectedOption: string = '0';
  tiposPeso: TiposPesoDTO[] = [];
  tipoPesoSeleccionado = null;
  esIvaSuspenso = false;
  esCodigoCorrecto = true;
  filteredTipoRetencion: Observable<TipoRetencionDTO[]>;

  precioUnitarioCtl = new FormControl('', [
    Validators.required,
    Validators.pattern(/^\d+\.\d{0,2}$/), // Permite hasta 2 decimales
  ]);

  referenciaOpcionalHabilitada: boolean = true;

  constructor(public detalleCfeComponentMatDialogRef: MatDialogRef<DetalleCfeComponent>, private fb: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public datosDetalleCFEDTO: DatosDetalleCFEDTO, private emisionCfeService: EmisionCfeService, private _snackBar: MatSnackBar) {

  }

  ngOnInit(): void {
    this.referenciaOpcionalHabilitada = true;
    console.log(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado)
    this.emisorEsLiteralE = this.emisionCfeService.getEmisorCFEDTO().esLiteralE;
    if (this.emisorEsLiteralE) {
      this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoImpuestoSeleccionado = this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.impuestosDTOs.find(impuesto => impuesto.descripcion == 'IVA exento').codigo;
      this.datosDetalleCFEDTO.detalleCFEDTO.impuesto = this.obtenerImpuesto(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoImpuestoSeleccionado);
      //this.calcularMontoIVA();
    }
    this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.tipoCFE;
    this.tipCodigos = this.datosDetalleCFEDTO.tiposCodigosIniciales;

    this.tiposPeso = this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.tiposPesoDTOs;
    const pesoUnidad = this.tiposPeso.find(tipoPeso => tipoPeso.descripcion === 'Unidad');
    this.tipoPesoSeleccionado = pesoUnidad.codigo;
    this.datosDetalleCFEDTO.detalleCFEDTO.tipoPeso = pesoUnidad.abreviatura;
    this.construirFormGroup();
    this.setearConditionalValidators();
    this.llenarOpcionesFiltro();
  }

  private construirFormGroup(): void {
    this.formGroup = new FormGroup({
      // Caso no e-Resguardo validators.
      descripcionControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.nombre, []),
      cantidadControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.cantidad, []),
      precioUnitarioControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.precioUnitario, []),
      precioVentaControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta, []),
      impuestoControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.impuesto, []),
      montoIVAControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA, []),
      montoTotalControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.montoTotal, []),
      tipoCodigoControl: new FormControl(null, []),
      tipoCodigoDescripcionControl: new FormControl('', []),
      tipoPesoControl: new FormControl(0, []),

      // Caso e-Resguardo validators.
      tipoRetencionEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.tipoRetencionEResg, []),
      tasaEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.tasaEResg, []),
      montoSujetoARetencionEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.montoSujetoARetencionEResg, []),
      montoRetenidoEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.montoRetenidoEResg, []),
      tipoCFERefCFEEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.tipoCFE, []),
      serieRefCFEEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.serie, []),
      numeroRefCFEEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.numero, []),
      fechaEmisionRefCFEEResgControl: new FormControl(this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.fechaEmision, [])
    });

    this.tipoCodigoFormGroup = new FormGroup({
      tipoCodigoControl: new FormControl(null, []),
      tipoCodigoDescripcionControl: new FormControl('', [Validators.maxLength(35)]),
    });

    this.codigoDinamicFormGroup = this.fb.group({
      codigos: this.fb.array([])
    });
  }

  private setearConditionalValidators(): void {
    const descripcionControl: AbstractControl = this.formGroup.get('descripcionControl');
    const cantidadControl: AbstractControl = this.formGroup.get('cantidadControl');
    const precioUnitarioControl: AbstractControl = this.formGroup.get('precioUnitarioControl');
    const precioVentaControl: AbstractControl = this.formGroup.get('precioVentaControl');
    const impuestoControl: AbstractControl = this.formGroup.get('impuestoControl');
    const montoIVAControl: AbstractControl = this.formGroup.get('montoIVAControl');
    const montoTotalControl: AbstractControl = this.formGroup.get('montoTotalControl');
    const tipoRetencionEResgControl: AbstractControl = this.formGroup.get('tipoRetencionEResgControl');
    const tasaEResgControl: AbstractControl = this.formGroup.get('tasaEResgControl');
    const montoSujetoARetencionEResgControl: AbstractControl = this.formGroup.get('montoSujetoARetencionEResgControl');
    const montoRetenidoEResgControl: AbstractControl = this.formGroup.get('montoRetenidoEResgControl');
    const tipoCFERefCFEEResgControl: AbstractControl = this.formGroup.get('tipoCFERefCFEEResgControl');
    const serieRefCFEEResgControl: AbstractControl = this.formGroup.get('serieRefCFEEResgControl');
    const numeroRefCFEEResgControl: AbstractControl = this.formGroup.get('numeroRefCFEEResgControl');
    const fechaEmisionRefCFEEResgControl: AbstractControl = this.formGroup.get('fechaEmisionRefCFEEResgControl');

    if (this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.esModoEResguardo) {
      descripcionControl.setValidators(null);
      cantidadControl.setValidators(null);
      precioUnitarioControl.setValidators(null);
      precioVentaControl.setValidators(null);
      impuestoControl.setValidators(null);
      montoIVAControl.setValidators(null);
      montoTotalControl.setValidators(null);
      tipoRetencionEResgControl.setValidators([Validators.required]);
      tasaEResgControl.setValidators([Validators.required]);
      montoSujetoARetencionEResgControl.setValidators([Validators.required]);
      montoRetenidoEResgControl.setValidators([Validators.required]);
      if (this.datosDetalleCFEDTO.esRut) {
        tipoCFERefCFEEResgControl.setValidators([Validators.required]);
        serieRefCFEEResgControl.setValidators([Validators.required]);
        numeroRefCFEEResgControl.setValidators([Validators.required]);
        fechaEmisionRefCFEEResgControl.setValidators([Validators.required]);
      } else {
        tipoCFERefCFEEResgControl.setValidators(null);
        serieRefCFEEResgControl.setValidators(null);
        numeroRefCFEEResgControl.setValidators(null);
        fechaEmisionRefCFEEResgControl.setValidators(null);
      }
    } else {
      descripcionControl.setValidators([Validators.required]);
      cantidadControl.setValidators([Validators.required]);
      precioUnitarioControl.setValidators([Validators.required, this.minExcluyente(0), Validators.max(100000000), Validators.pattern(/^(?!0\d)\d*(\.\d+)?$/)]);
      precioVentaControl.setValidators([Validators.required]);
      impuestoControl.setValidators([Validators.required]);
      montoIVAControl.setValidators([Validators.required]);
      montoTotalControl.setValidators([Validators.required]);
      tipoRetencionEResgControl.setValidators(null);
      tasaEResgControl.setValidators(null);
      montoSujetoARetencionEResgControl.setValidators(null);
      montoRetenidoEResgControl.setValidators(null);
      tipoCFERefCFEEResgControl.setValidators(null);
      serieRefCFEEResgControl.setValidators(null);
      numeroRefCFEEResgControl.setValidators(null);
      fechaEmisionRefCFEEResgControl.setValidators(null);
    }

    descripcionControl.updateValueAndValidity();
    cantidadControl.updateValueAndValidity();
    precioUnitarioControl.updateValueAndValidity();
    precioVentaControl.updateValueAndValidity();
    impuestoControl.updateValueAndValidity();
    montoIVAControl.updateValueAndValidity();
    montoTotalControl.updateValueAndValidity();
    tipoRetencionEResgControl.updateValueAndValidity();
    tasaEResgControl.updateValueAndValidity();
    montoSujetoARetencionEResgControl.updateValueAndValidity();
    montoRetenidoEResgControl.updateValueAndValidity();
    tipoCFERefCFEEResgControl.updateValueAndValidity();
    serieRefCFEEResgControl.updateValueAndValidity();
    numeroRefCFEEResgControl.updateValueAndValidity();
    fechaEmisionRefCFEEResgControl.updateValueAndValidity();
  }

  minExcluyente(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value <= min) {
        return {minExcluyente: {min, actual: value}};
      }
      return null;
    };
  }

  get descripcionControl(): AbstractControl {
    return this.formGroup.get('descripcionControl');
  }

  get cantidadControl(): AbstractControl {
    return this.formGroup.get('cantidadControl');
  }

  get precioUnitarioControl(): AbstractControl {
    return this.formGroup.get('precioUnitarioControl');
  }

  get precioVentaControl(): AbstractControl {
    return this.formGroup.get('precioVentaControl');
  }

  get impuestoControl(): AbstractControl {
    return this.formGroup.get('impuestoControl');
  }

  get montoIVAControl(): AbstractControl {
    return this.formGroup.get('montoIVAControl');
  }

  get montoTotalControl(): AbstractControl {
    return this.formGroup.get('montoTotalControl');
  }

  get tipoRetencionEResgControl(): AbstractControl {
    return this.formGroup.get('tipoRetencionEResgControl');
  }

  get tasaEResgControl(): AbstractControl {
    return this.formGroup.get('tasaEResgControl');
  }

  get montoSujetoARetencionEResgControl(): AbstractControl {
    return this.formGroup.get('montoSujetoARetencionEResgControl');
  }

  get montoRetenidoEResgControl(): AbstractControl {
    return this.formGroup.get('montoRetenidoEResgControl');
  }

  get tipoCFERefCFEEResgControl(): AbstractControl {
    return this.formGroup.get('tipoCFERefCFEEResgControl');
  }

  get serieRefCFEEResgControl(): AbstractControl {
    return this.formGroup.get('serieRefCFEEResgControl');
  }

  get numeroRefCFEEResgControl(): AbstractControl {
    return this.formGroup.get('numeroRefCFEEResgControl');
  }

  get fechaEmisionRefCFEEResgControl(): AbstractControl {
    return this.formGroup.get('fechaEmisionRefCFEEResgControl');
  }

  public hayControlError(control: AbstractControl): boolean {
    return (control.invalid && (control.dirty || control.touched) && control.errors.required);
  }

  get errorMessage(): string {
    const form: FormControl = (this.formGroup.get('precioUnitarioControl') as FormControl);
    let errorString = '';
    if (form.hasError('required')) {
      errorString = 'El precio unitario es requerido.';
    }

    if (form.hasError('minExcluyente')) {
      errorString = 'Debe ser mayor que cero.';
    }

    if (form.hasError('max')) {
      errorString = 'Debe ser menor que 100 millones.';
    }

    if (form.hasError('pattern')) {
      errorString = 'El valor está mal formateado.';
    }

    return errorString;
  }

  private obtenerImpuesto(codigoImpuesto: number): ImpuestoDTO {
    let impuestoARetornarDTO: ImpuestoDTO = null;
    for (const impuestoDTO of this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.impuestosDTOs) {
      if (impuestoDTO.codigo === codigoImpuesto) {
        impuestoARetornarDTO = impuestoDTO;
        break;
      }
    }

    return impuestoARetornarDTO;
  }

  private obtenerTipoRetencion(codigoTipoRetencion: number): TipoRetencionDTO {
    return this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.tiposRetencionesDTOs.find((tipoRetencionDTO) => {
      return (codigoTipoRetencion === tipoRetencionDTO.codigo);
    });
  }

  private obtenerTipoCFE(codigoTipoCFE: number): TipoCFEDTO {
    return this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.tiposCFEsDTOs.find((tipoCFEDTO) => {
      return (codigoTipoCFE === tipoCFEDTO.codigo);
    });
  }

  private calcularPrecioVenta(): void {
    if (this.datosDetalleCFEDTO.detalleCFEDTO.cantidad !== undefined && this.datosDetalleCFEDTO.detalleCFEDTO.precioUnitario !== undefined) {
      this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta = this.redondearHaciaAbajo(this.datosDetalleCFEDTO.detalleCFEDTO.cantidad * this.datosDetalleCFEDTO.detalleCFEDTO.precioUnitario, 2);
      this.calcularMontoIVA();
    }
  }

  private calcularMontoIVA(): void {
    if (this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta !== undefined && this.datosDetalleCFEDTO.detalleCFEDTO.impuesto !== null) {
      if (!this.datosDetalleCFEDTO.detalleCFEDTO.tieneIVAIncluido) {
        const tasa: number = this.datosDetalleCFEDTO.detalleCFEDTO.impuesto.tasaVigenciaImpuesto.tasa;
        this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA = this.redondearHaciaAbajo(this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta * (tasa / 100), 2);
        this.calcularMontoTotal();
      } else {
        const coeficienteTasa = (this.datosDetalleCFEDTO.detalleCFEDTO.impuesto.tasaVigenciaImpuesto.tasa + 100) / 100;
        const precioUnitario = this.datosDetalleCFEDTO.detalleCFEDTO.precioUnitario;
        this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA = this.redondearHaciaAbajo((precioUnitario - precioUnitario / coeficienteTasa) * this.datosDetalleCFEDTO.detalleCFEDTO.cantidad, 2);
        this.calcularMontoTotal();
      }

      this.precioVentaControl.setValue(this.obtenerMonto(this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta));
      this.montoIVAControl.setValue(this.obtenerMonto(this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA));

      this.esIvaSuspenso = this.datosDetalleCFEDTO.detalleCFEDTO.impuesto.descripcion === 'IVA suspenso';

      if (this.esIvaSuspenso) {
        this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA = 0;
        this.montoIVAControl.setValue(0);
        this.montoIVAControl.markAsTouched();
      }
    }
  }

  private calcularMontoTotal(): void {
    if (this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta !== undefined && this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA !== undefined) {
      if (!this.datosDetalleCFEDTO.detalleCFEDTO.tieneIVAIncluido) {
        const montoTotal = this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta + this.datosDetalleCFEDTO.detalleCFEDTO.montoIVA;
        this.datosDetalleCFEDTO.detalleCFEDTO.montoTotal = this.redondearHaciaAbajo(montoTotal, 2);
      } else {
        this.datosDetalleCFEDTO.detalleCFEDTO.montoTotal = this.datosDetalleCFEDTO.detalleCFEDTO.precioVenta;
      }

      this.montoTotalControl.setValue(this.obtenerMonto(this.datosDetalleCFEDTO.detalleCFEDTO.montoTotal));
    }
  }

  private calcularMontoTotalRetenido(): void {
    if (this.datosDetalleCFEDTO.detalleCFEDTO.montoSujetoARetencionEResg !== undefined && this.datosDetalleCFEDTO.detalleCFEDTO.tasaEResg !== null) {
      const tasaEResg: number = this.datosDetalleCFEDTO.detalleCFEDTO.tasaEResg;
      this.datosDetalleCFEDTO.detalleCFEDTO.montoRetenidoEResg = this.datosDetalleCFEDTO.detalleCFEDTO.montoSujetoARetencionEResg * (tasaEResg / 100);
    }
  }

  public onCantidadChange(): void {
    this.calcularPrecioVenta();
  }

  public onPrecioUnitarioChange(): void {
    this.calcularPrecioVenta();
  }

  public onImpuestoChange(): void {
    const impuestoDTO: ImpuestoDTO = this.obtenerImpuesto(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoImpuestoSeleccionado);
    this.datosDetalleCFEDTO.detalleCFEDTO.impuesto = impuestoDTO;

    this.calcularMontoIVA();
  }

  public onTipoRetencionChange(): void {
    const tipoRetencionDTO: TipoRetencionDTO = this.obtenerTipoRetencion(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado);
    this.datosDetalleCFEDTO.detalleCFEDTO.tipoRetencionEResg = tipoRetencionDTO;
  }

  public onTipoCFEChange(): void {
    const tipoCFEDTO: TipoCFEDTO = this.obtenerTipoCFE(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado);
    this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.tipoCFE = tipoCFEDTO;
  }

  public onTasaChange(): void {
    this.calcularMontoTotalRetenido();
  }

  public onMontoSujetoARetencionChange(): void {
    this.calcularMontoTotalRetenido();
  }

  truncateNumber(value: number): number {
    const parts = value.toString().split('.');
    if (parts.length < 2 || parts[1].length <= 6) {
      return value;
    }
    const integerPart = parts[0];
    const decimalPart = parts[1].substring(0, 6);
    return parseFloat(`${integerPart}.${decimalPart}`);
  }

  roundOffNumber(value: number): number {
    const numberSTr = value.toString();
    const [integer, decimals] = numberSTr.split('.');
    if (!decimals || decimals.length <= 2) {
      return value;
    }
    // const result = parseFloat(`${integer}.${decimals.slice(0, 2)}`);
    const result = parseFloat(value.toFixed(2));

    return result;
  }

  formatNumber(event: any) {
    const formattedValue = this.truncateNumber(event.target.value);
    this.precioUnitarioControl.setValue(formattedValue);
  }


  get codigos(): FormArray {
    return this.codigoDinamicFormGroup.get('codigos') as FormArray;
  }


  verifyAndAdd() {
    const value = this.tipCodigos.find(tipCodigo => tipCodigo.codigo === this.tipoCodigoFormGroup.get('tipoCodigoControl').value).descripcion;
    if (value === 'EAN') {
      if (Utils.esCodigoGTINValido(this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').value)) {
        this.addNewItem();
        this.esCodigoCorrecto = true;
      } else {
        const control = this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl');
        control.setErrors({invalid: true});
        this.esCodigoCorrecto = false;

        this._snackBar.open('El código EAN proporcionado no es válido.', 'Cerrar', {
          duration: 5000,  // Duración en milisegundos
          panelClass: ['error-toast'],  // Clase CSS personalizada para estilos adicionales
        });
      }
    } else {
      this.addNewItem();
      this.esCodigoCorrecto = true;
    }
  }

  addNewItem() {

    (this.codigoDinamicFormGroup.controls.codigos as FormArray).push(new FormGroup({
      codigo: new FormControl('', [])
    }));

    const detalleTipoCodigoDTO = new DetalleTipoCodigoDTO();
    detalleTipoCodigoDTO.tipoCodigo = this.tipoCodigoFormGroup.get('tipoCodigoControl').value;
    detalleTipoCodigoDTO.value = this.tipCodigos.find(tipCodigo => tipCodigo.codigo === this.tipoCodigoFormGroup.get('tipoCodigoControl').value).descripcion;
    detalleTipoCodigoDTO.codigo = this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').value;

    this.datosDetalleCFEDTO.detalleCFEDTO.tipoCodigos.push(detalleTipoCodigoDTO);
    this.tipoCodigoFormGroup.get('tipoCodigoControl').setValue(null);
    this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').setValue('');
  }

  canAdd(): boolean {
    const codigo = this.tipoCodigoFormGroup.get('tipoCodigoControl').value;
    const descripcion = this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').value;
    return codigo != null && descripcion !== '' && !this.existTipoCodigo(codigo) && this.datosDetalleCFEDTO.detalleCFEDTO.tipoCodigos.length < 5 && descripcion.length <= 35;
  }

  existTipoCodigo(codigo: any) {
    return this.datosDetalleCFEDTO.detalleCFEDTO.tipoCodigos.some(tipoCodigo => codigo === tipoCodigo.tipoCodigo);
  }

  removeComponent(value: boolean, pos: number) {
    if (value) {
      this.datosDetalleCFEDTO.detalleCFEDTO.tipoCodigos.splice(pos, 1);
    }
  }

  updateTiposCodigo(updatedValues: DetalleTipoCodigoDTO[]) {
    this.datosDetalleCFEDTO.detalleCFEDTO.tipoCodigos = updatedValues;
    this.canAccept = updatedValues.every(element => element.numero === 0);
  }

  enableAgregarButton() {
    if (this.formGroup.get('serieRefCFEEResgControl').value === '') {
      this.formGroup.get('serieRefCFEEResgControl').setValue(undefined);
    }
    if (this.formGroup.get('numeroRefCFEEResgControl').value === '') {
      this.formGroup.get('numeroRefCFEEResgControl').setValue(undefined);
    }
    if (this.formGroup.get('fechaEmisionRefCFEEResgControl').value === null) {
      this.formGroup.get('fechaEmisionRefCFEEResgControl').setValue(undefined);
    }
    if (this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.esModoEResguardo) {
      return this.datosDetalleCFEDTO.esRut ||
        ((this.formGroup.get('tipoCFERefCFEEResgControl').value === null && this.formGroup.get('serieRefCFEEResgControl').value === null && this.formGroup.get('numeroRefCFEEResgControl').value === null && this.formGroup.get('fechaEmisionRefCFEEResgControl').value === undefined) ||
          (this.formGroup.get('tipoCFERefCFEEResgControl').value !== null && this.formGroup.get('serieRefCFEEResgControl').value !== null && this.formGroup.get('numeroRefCFEEResgControl').value !== null && this.formGroup.get('fechaEmisionRefCFEEResgControl').value !== undefined));
    } else {
      return true;
    }

  }

  convertirAMayusculas(event: any) {
    const expresionRegular = /^[a-mo-zA-Z]{1,2}$/;
    if (expresionRegular.test(event.target.value)) {
      this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.serie = event.target.value.toUpperCase();
    } else {
      this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.serie = '';
      this.serieRefCFEEResgControl.setValue('');
    }
  }

  obtenerMonto(value: number): string {
    if (value !== undefined) {
      return value.toFixed(2);
    } else {
      return '';
    }
  }

  redondearHaciaAbajo(number: number, decimalPlaces: number): number {
    const factor = Math.pow(10, decimalPlaces);
    const roundedNum = Math.round(number * factor) / factor;
    const truncatedNum = Math.trunc(number * factor) / factor;
    const truncatedIntegerValue = Math.trunc(number * factor);
    const referenceValue = number * factor - truncatedIntegerValue;

    if (referenceValue <= 0.5) {
      return truncatedNum;
    } else {
      return roundedNum;
    }
  }

  public onTipoPesoChange(): void {
    this.datosDetalleCFEDTO.detalleCFEDTO.tipoPeso = this.tiposPeso.find(tipoPeso => tipoPeso.codigo === this.tipoPesoSeleccionado).abreviatura;
  }

  ivaInclChangeCheckStatus(event: any) {
    this.datosDetalleCFEDTO.detalleCFEDTO.tieneIVAIncluido = event.checked;
    this.calcularMontoIVA();
  }

  agregarDetalle() {
    if (this.tipoCodigoFormGroup.get('tipoCodigoControl').value != null && this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').value != null) {
      this.verifyAndAdd();
      if (this.esCodigoCorrecto) {
        this.detalleCfeComponentMatDialogRef.close(this.datosDetalleCFEDTO.detalleCFEDTO);
      }
    } else {
      this.detalleCfeComponentMatDialogRef.close(this.datosDetalleCFEDTO.detalleCFEDTO);
    }
  }

  llenarOpcionesFiltro() {
    this.filteredTipoRetencion = this.tipoRetencionEResgControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  private _filter(value: string): TipoRetencionDTO[] {
    const filterValue = value.toLowerCase();

    return this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.tiposRetencionesDTOs
      .filter(tipoRetencion => (tipoRetencion.numeroForm + '-' + tipoRetencion.cLinea + '-' + tipoRetencion.descripcion).toLowerCase().includes(filterValue))
      .sort();
  }

  public onDocumentoSelect(event): void {
    this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado = event.codigo;
    const tipoRetencionDTO: TipoRetencionDTO = this.obtenerTipoRetencion(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado);
    this.datosDetalleCFEDTO.detalleCFEDTO.tipoRetencionEResg = tipoRetencionDTO;
  }

  displayFn(tipo: TipoRetencionDTO): string {
    return tipo && tipo.descripcion ? tipo.numeroForm + '-' + tipo.cLinea + '-' + tipo.descripcion : '';
  }

  obtenerDescripcionCompleta() {
    if (this.tipoRetencionEResgControl.value != null && this.tipoRetencionEResgControl.value !== '' && this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado != null) {
      const tipoRetencionDTO: TipoRetencionDTO = this.obtenerTipoRetencion(this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado);
      return 'Nro. de formulario: ' + tipoRetencionDTO.numeroForm + ' Nro. de línea: ' + tipoRetencionDTO.cLinea + ' Descripción: ' + tipoRetencionDTO.descripcion;
    } else {
      return '';
    }
  }

  onInputChange(event) {
    if (event.data == null) {
      this.llenarOpcionesFiltro();
      this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado = null;
    }
  }

  validarTipoRetencion() {
    if (this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado == null) {
      this.tipoRetencionEResgControl.setValue('');
    }
  }

  obtenerImpuestos() {
    let impuestos = [];
    const codigoSeleccionado = this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado;
    this.datosDetalleCFEDTO.datosInicioDetalleCFEDTO.impuestosDTOs.forEach((impuesto) => {
        if ([121, 122, 123].includes(codigoSeleccionado)) {
          if (impuesto.codigo === 5) {
            impuestos.push(impuesto);
          }
        } else {
          if (impuesto.codigo !== 5) {
            impuestos.push(impuesto);
          }
        }
      });

    return impuestos;
  }

  onValueChange(value: string) {
    this.datosDetalleCFEDTO.detalleCFEDTO.descripcionAdicional = value;
    console.log(this.datosDetalleCFEDTO.detalleCFEDTO.descripcionAdicional)
  }

  toggleReferenciaControles(habilitar: boolean) {
    this.referenciaOpcionalHabilitada = habilitar;

    if (habilitar) {
      this.tipoCFERefCFEEResgControl.setValidators(Validators.required);
      this.serieRefCFEEResgControl.setValidators(Validators.required);
      this.numeroRefCFEEResgControl.setValidators(Validators.required);
      this.fechaEmisionRefCFEEResgControl.setValidators(Validators.required);
    } else {
      this.tipoCFERefCFEEResgControl.setValidators(null);
      this.serieRefCFEEResgControl.setValidators(null);
      this.numeroRefCFEEResgControl.setValidators(null);
      this.fechaEmisionRefCFEEResgControl.setValidators(null);
    }

    this.tipoCFERefCFEEResgControl.reset();
    this.serieRefCFEEResgControl.reset();
    this.numeroRefCFEEResgControl.reset();
    this.fechaEmisionRefCFEEResgControl.reset();

    this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.tipoCFE = null;
    this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.serie = null;
    this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.numero = null;
    this.datosDetalleCFEDTO.detalleCFEDTO.referenciaCFEEResg.fechaEmision = null;

    this.tipoCFERefCFEEResgControl.updateValueAndValidity();
    this.serieRefCFEEResgControl.updateValueAndValidity();
    this.numeroRefCFEEResgControl.updateValueAndValidity();
    this.fechaEmisionRefCFEEResgControl.updateValueAndValidity();
  }

}
